export class HttpHeaderModel {
  public customerAreaMessageEtag: number | null | undefined;
  public laboratoryAreaMessageEtag: number | null | undefined;
  public previousCustomerAreaMessageEtag: number | null | undefined;
  public previousLaboratoryAreaMessageEtag: number | null | undefined;

  public constructor(
    customerAreaMessageEtag: number | null | undefined,
    laboratoryAreaMessageEtag: number | null | undefined,
    previousCustomerAreaMessageEtag: number | null | undefined,
    previousLaboratoryAreaMessageEtag: number | null | undefined,
  ) {
    this.customerAreaMessageEtag = customerAreaMessageEtag;
    this.laboratoryAreaMessageEtag = laboratoryAreaMessageEtag;
    this.previousCustomerAreaMessageEtag = previousCustomerAreaMessageEtag;
    this.previousLaboratoryAreaMessageEtag = previousLaboratoryAreaMessageEtag;
  }
}
